export * from './bericht-hochgeladen.interface';
